import type {ReactElement} from 'react';
import React from 'react';
import {SocialProfileIconSize} from '@Components/social-media/components/social-profile-icon';
import {noop} from '@Utils/general.util';
import {Text, TextSize} from '@Components/text';
import {ClickableDiv} from '@Components/clickable-div';
import styles from './social-profile-icon-placeholder.module.scss';

interface SocialProfileIconPlaceholderProps {
  countToShow: number;
  size: SocialProfileIconSize;
  onClick?: VoidFunction;
  className?: string;
}

export function SocialProfileIconPlaceholder({countToShow, size, onClick = noop, className = ''}: SocialProfileIconPlaceholderProps): ReactElement {
  const getClassesForSize = (): string => {
    switch (size) {
      case SocialProfileIconSize.MEDIUM:
        return styles.medium;
      case SocialProfileIconSize.LARGE:
        return styles.large;
      default:
        return styles.medium;
    }
  };

  const getTextSize = (): TextSize => {
    switch (size) {
      case SocialProfileIconSize.MEDIUM:
        return TextSize.XSMALL;
      case SocialProfileIconSize.LARGE:
        return TextSize.SMALL;
      default:
        return TextSize.SMALL;
    }
  };

  return (
    <ClickableDiv className={`${styles.placeholderIcon} ${getClassesForSize()} ${className}`} onClick={onClick}>
      <Text val={`+${countToShow}`} size={getTextSize()} bold />
    </ClickableDiv>
  );
}
